var map = {
	"./Andromeda.png": "b441",
	"./Antlia.png": "1719",
	"./Apus.png": "89ce",
	"./Aquarius.png": "2695",
	"./Aquila.png": "f280",
	"./Ara.png": "7a90",
	"./Aries.png": "80d1",
	"./Auriga.png": "ba7b",
	"./Bootes.png": "85de",
	"./Caelum.png": "8c61",
	"./Camelopardalis.png": "e4eb",
	"./Cancer.png": "4726",
	"./Canes_venatici.png": "7d73",
	"./Canis_major.png": "01a0",
	"./Canis_minor.png": "e48e",
	"./Capricornus.png": "3d7f",
	"./Carina.png": "e914",
	"./Cassiopeia.png": "e098",
	"./Centaurus.png": "b970",
	"./Cepheus.png": "b1af",
	"./Cetus.png": "71f0",
	"./Chamaeleon.png": "35ea",
	"./Circinus.png": "3b33",
	"./Columba.png": "462f",
	"./Coma_berenices.png": "56d7",
	"./Corona_australis.png": "9184",
	"./Corona_borealis.png": "3a64",
	"./Corvus.png": "b364",
	"./Crater.png": "0dbc",
	"./Crux.png": "908b",
	"./Cygnus.png": "3add",
	"./Delphinus.png": "71af",
	"./Dorado.png": "38fe",
	"./Draco.png": "cb74",
	"./Equuleus.png": "9408",
	"./Eridanus.png": "e8d4",
	"./Fornax.png": "942b",
	"./Gemini.png": "a881",
	"./Grus.png": "99f2",
	"./Hercules.png": "c4ab",
	"./Horologium.png": "9892",
	"./Hydra.png": "ec45",
	"./Hydrus.png": "f938",
	"./Indus.png": "d340",
	"./Lacerta.png": "291d",
	"./Leo.png": "a426",
	"./Leo_minor.png": "efa4",
	"./Lepus.png": "5340",
	"./Libra.png": "2e5c",
	"./Lupus.png": "0e08b",
	"./Lynx.png": "8b0a",
	"./Lyra.png": "0ba1",
	"./Mensa.png": "efa7",
	"./Microscopium.png": "6444",
	"./Monoceros.png": "c90f",
	"./Musca.png": "e900",
	"./Norma.png": "6cb4",
	"./Octans.png": "3d19",
	"./Ophiuchus.png": "529c",
	"./Orion.png": "d6e1",
	"./Pavo.png": "1142",
	"./Pegasus.png": "fcf1",
	"./Perseus.png": "c96c",
	"./Phoenix.png": "c501",
	"./Pictor.png": "1f73",
	"./Pisces.png": "d0c0",
	"./Piscis_austrinus.png": "31a7",
	"./Puppis.png": "8ed5",
	"./Pyxis.png": "d56e",
	"./Reticulum.png": "58e2",
	"./Sagitta.png": "aa83",
	"./Sagittarius.png": "df5f",
	"./Scorpius.png": "f7d8",
	"./Sculptor.png": "d408",
	"./Scutum.png": "bc20",
	"./Serpens.png": "8cd8",
	"./Sextans.png": "767a",
	"./Taurus.png": "d2e1",
	"./Telescopium.png": "f1f0",
	"./Triangulum.png": "c03e",
	"./Triangulum_australe.png": "cbf9",
	"./Tucana.png": "7965",
	"./Ursa_major.png": "1877",
	"./Ursa_minor.png": "c9e9",
	"./Vela.png": "7371",
	"./Virgo.png": "e5ff",
	"./Volans.png": "aac7",
	"./Vulpecula.png": "f6be"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3937";